export default "__VITE_ASSET__C6brO1dT__"